
export default {
    state: {
        isSehattyPage: false,
    },
    getters: {
        isSehattyPage(state: any) {
            return state.isSehattyPage;
        }
    },
    actions: {
        updateSehattyPage({ commit }: any, route: any) {
            const isSehatty = route.fullPath.includes('sehatty');
            commit('setSehattyPage', isSehatty);
        }

    },
    mutations: {
        setSehattyPage(state: any, value: boolean) {
            state.isSehattyPage = value;
        }
    }
}